import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class FontAccessibilityService {

  sharedStyleSource = new Subject<any>();
  public sharedStyle$ = this.sharedStyleSource.asObservable();
  savedFont : string;

  constructor() {
    if(localStorage.getItem('accFont')){
      this.savedFont = localStorage.getItem('accFont');
    }
   }

  newStyle(value: any) {
    this.sharedStyleSource.next(value[0]);
  }
}
